var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9599 0.544442C12.9113 0.246745 12.653 0.0195312 12.3415 0.0195312C11.9955 0.0195312 11.715 0.300042 11.715 0.64607V1.6903H6.285V0.64607L6.2768 0.544442C6.22824 0.246745 5.96989 0.0195312 5.65846 0.0195312C5.31243 0.0195312 5.03192 0.300042 5.03192 0.64607V1.6903H3.56998C2.07053 1.6903 0.85498 2.90585 0.85498 4.4053V7.32917V15.2653C0.85498 16.7648 2.07053 17.9803 3.56998 17.9803H14.43C15.9294 17.9803 17.145 16.7648 17.145 15.2653V7.32917V4.4053C17.145 2.90585 15.9294 1.6903 14.43 1.6903H12.9681V0.64607L12.9599 0.544442ZM15.8919 6.70263V4.40541C15.8919 3.59801 15.2374 2.94349 14.43 2.94349H12.9681V3.98761C12.9681 4.33364 12.6876 4.61415 12.3415 4.61415C12.0301 4.61415 11.7718 4.38693 11.7232 4.08924L11.715 3.98761V2.94349H6.285V3.98761C6.285 4.33364 6.00449 4.61415 5.65846 4.61415C5.34704 4.61415 5.08868 4.38693 5.04012 4.08924L5.03192 3.98761V2.94349H3.56999C2.76259 2.94349 2.10807 3.59801 2.10807 4.40541V6.70263H15.8919ZM2.10807 7.95571H15.8919V15.2654C15.8919 16.0728 15.2374 16.7273 14.43 16.7273H3.56999C2.76259 16.7273 2.10807 16.0728 2.10807 15.2654V7.95571Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGray);
export default __webpack_public_path__ + "static/media/calendar-gray.20e2521f164cc8eb75a1e8ac39249a1b.svg";
export { ForwardRef as ReactComponent };